<template>
	<v-app>
		<v-main>
			<v-container class="fill-height" fluid style="background: #ffffff; min-height: 100vh">
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="6" lg="4">
						<v-card class="elevation-12 rounded-lg">
							<v-card-title class="primary white--text justify-center py-6">
								<div class="text-center">
									<img v-if="portalLogo" :src="portalLogo" alt="" style="max-height: 60px; margin-bottom: 8px;">
									<v-icon v-else dark x-large class="mb-2">mdi-domain</v-icon>
									<div class="text-h5 font-weight-bold">{{ portalName }}</div>
								</div>
							</v-card-title>
							<v-card-text class="pa-6">
								<div class="text-subtitle-1 text-center grey--text mb-4">Seleziona un'azienda</div>
								<v-list>
									<v-list-item
										v-for="company in companies"
										:key="company.id"
										@click="selectCompany(company)"
										class="mb-2 rounded-lg"
										style="border: 1px solid #e0e0e0"
									>
										<v-list-item-avatar>
											<v-icon color="primary">mdi-domain</v-icon>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title class="font-weight-medium">{{ company.name }}</v-list-item-title>
										</v-list-item-content>
										<v-list-item-action>
											<v-chip x-small :color="roleColor(company.role)" text-color="white">{{ roleLabel(company.role) }}</v-chip>
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
							<v-card-actions class="px-6 pb-4">
								<v-btn text small color="grey" @click="logout">
									<v-icon left small>mdi-logout</v-icon>
									Esci
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
export default {
	name: 'PortalCompanySelect',
	computed: {
		companies() {
			return this.$store.getters.portalCompanies
		},
		portalLogo() {
			try {
				const cached = JSON.parse(localStorage.getItem('portal-branding') || '{}')
				return cached.portal_logo || null
			} catch (e) {
				return null
			}
		},
		portalName() {
			try {
				const cached = JSON.parse(localStorage.getItem('portal-branding') || '{}')
				return cached.portal_company_name || 'Area Privata'
			} catch (e) {
				return 'Area Privata'
			}
		}
	},
	created() {
		// Carica branding
		const cached = localStorage.getItem('portal-branding')
		if (cached) {
			try {
				const d = JSON.parse(cached)
				if (d.portal_color) {
					this.$vuetify.theme.themes.light.primary = d.portal_color
					this.$vuetify.theme.themes.dark.primary = d.portal_color
				}
			} catch (e) { /* ignora */ }
		}
	},
	methods: {
		async selectCompany(company) {
			await this.$store.dispatch('PORTAL_SELECT_COMPANY', company.id)
			this.$router.push('/portal')
		},
		roleLabel(role) {
			const map = { limited: 'Limitato', user: 'Utente', manager: 'Manager' }
			return map[role] || role
		},
		roleColor(role) {
			const map = { limited: 'grey', user: 'blue', manager: 'green' }
			return map[role] || 'grey'
		},
		async logout() {
			await this.$store.dispatch('PORTAL_LOGOUT')
		}
	}
}
</script>
